import { BoltIcon } from "@heroicons/react/24/outline";
import React from "react";

interface Props {
  showWebhookIntegrations: boolean;
  setShowWebhookIntegrations: (val: boolean) => void;
}

export default function CustomWebhookTabTypeHeader({ showWebhookIntegrations, setShowWebhookIntegrations }: Props): JSX.Element {
  return (
    <div className="flex flex-row gap-x-4 self-end">
      <a
        onClick={() => {
          setShowWebhookIntegrations(true);
        }}
        className={`cursor-pointer inline-flex items-center px-1 pb-[2.02px] text-sm font-medium leading-5 border-b-2 group focus:outline-none
${
  showWebhookIntegrations
    ? "text-gray-800 border-primary-main focus:text-blue-800 focus:border-blue-700"
    : "text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300 focus:text-gray-700 focus:border-gray-300"
}`}
      >
        <span>Existing Integrations</span>
      </a>
      <a
        onClick={() => {
          setShowWebhookIntegrations(false);
        }}
        className={`cursor-pointer inline-flex items-center px-1 text-sm font-medium leading-5 border-b-2 group focus:outline-none
${
  !showWebhookIntegrations
    ? "text-gray-800 border-primary-main focus:text-blue-800 focus:border-blue-700"
    : "text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300 focus:text-gray-700 focus:border-gray-300"
}`}
      >
        <span>Custom Webhook</span>
      </a>
    </div>
  );
}
